import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.goal || initialState;

export const selectGoal = createSelector([selectSlice], state => state);
